import { gql } from "@apollo/client";

const CREATE_DIRECT_UPLOAD = gql`
  mutation DirectUpload($input: CreateDirectUploadInput!) {
    createDirectUpload(input: $input) {
      directUpload {
        signedBlobId
        url
        headers
      }
    }
  }
`;

export default CREATE_DIRECT_UPLOAD;
